<template> 
    <div class="card card-menu mb-5 mb-xxl-8"  v-if="model">
        <div class="card-body pt-3 pb-0">
            <div class="d-flex flex-wrap flex-sm-nowrap">
                <div class="flex-grow-1">
                    <div class="d-flex justify-content-between align-items-start flex-wrap">
                        <div class="d-flex flex-column">
                            <div class="d-flex align-items-center">
                                <div class="text-white fs-2 fw-bolder me-1">{{ model.descricao }}</div>
                                <div>
                                    <span class="svg-icon svg-icon-1 svg-icon-primary">
                                        <inline-svg src="media/icons/duotone/Design/Verified.svg" />
                                    </span>
                                </div>
                            </div>
                            <div class="d-flex flex-wrap fw-bold fs-6 mb-4 pe-2">
                                <span
                                    class="d-flex align-items-center text-gray-400 text-hover-primary me-5">
                                    <span class="svg-icon svg-icon-4 me-1">
                                        <inline-svg src="media/icons/duotone/General/Star.svg" />
                                    </span>
                                    Disciplina
                                </span> 
                            </div>
                        </div>
                        <div class="d-flex my-2">
                            <button @click="setModelUpdate" class="btn btn-sm btn-light me-2" btn-set-rota data-bs-toggle="modal" :data-bs-target="'#'+ modal_atualizar " v-if="hasPermissaoEditar">  
                                <span class="menu-icon">
                                    <i class="fas fa-edit fa-2x bi fs-2x text-pmes-primary" ></i> 
                                </span>
                                Editar
                            </button> 
                            <Editar @update-disciplina-alterado="buscaDisciplina" :service="service" :modelo="model_update" :modal="modal_atualizar" v-if="hasPermissaoEditar" :perfis="perfis"/>  
                             
                        </div>
                    </div>  
                </div>
            </div>
            <div class="d-flex overflow-auto h-55px">
                <ul
                    class="nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-6 fw-bolder flex-nowrap">
                    <li class="nav-item"> 
                        <router-link :to="{ name: 'sigap_disciplina_dados' , params: {  id:model.id  } }" class="nav-link text-active-secondary me-6"
                            active-class="active">
                            Dados
                        </router-link>
                    </li>
                    <li class="nav-item"> 
                        <router-link :to="{ name: 'sigap_disciplina_instrutores' , params: {  id:model.id  } }" class="nav-link text-active-secondary me-6"
                            active-class="active">
                            Instrutores
                        </router-link>
                    </li>
                    <li class="nav-item">
                        <router-link class="nav-link text-active-secondary me-6 " :to="{ name: 'sigap_disciplina_aulas' , params: {  id:model.id  } }"
                            active-class="active">
                            Aulas
                        </router-link>
                    </li>
                    <li class="nav-item">
                        <router-link class="nav-link text-active-secondary me-6 " :to="{ name: 'sigap_disciplina_avaliacoes' , params: {  id:model.id  } }"
                            active-class="active">
                            Notas
                        </router-link>
                    </li>
                    <li class="nav-item">
                        <router-link class="nav-link text-active-secondary me-6 " :to="{ name: 'sigap_disciplina_avaliacoes_pendentes' , params: {  id:model.id  } }"
                            active-class="active">
                            Notas Pendentes
                        </router-link>
                    </li>
                    <li class="nav-item">
                        <router-link class="nav-link text-active-secondary me-6 " :to="{ name: 'sigap_disciplina_faltas' , params: {  id:model.id  } }"
                            active-class="active">
                            Faltas
                        </router-link>
                    </li>
                    <li class="nav-item">
                        <router-link class="nav-link text-active-secondary me-6 " :to="{ name: 'sigap_disciplina_vf' , params: {  id:model.id  } }"
                            active-class="active">
                            VF
                        </router-link>
                    </li>
                    <li class="nav-item">
                        <router-link class="nav-link text-active-secondary me-6 " :to="{ name: 'sigap_disciplina_reprovacao' , params: {  id:model.id  } }"
                            active-class="active">
                            Reprovação
                        </router-link>
                    </li> 
                    <li class="nav-item">
                        <router-link class="nav-link text-active-secondary me-6 " :to="{ name: 'sigap_disciplina_faltas_agrupadas' , params: {  id:model.id  } }"
                            active-class="active">
                            Faltas Agrupadas
                        </router-link>
                    </li> 
                    <li class="nav-item">
                        <router-link class="nav-link text-active-secondary me-6 " :to="{ name: 'sigap_disciplina_requisitos' , params: {  id:model.id  } }"
                            active-class="active">
                            Pré Requisito
                        </router-link>
                    </li> 
                    <li class="nav-item">
                        <router-link class="nav-link text-active-secondary me-6 " :to="{ name: 'sigap_disciplina_requisitosalunos' , params: {  id:model.id  } }"
                            active-class="active">
                            Alunos sem Pré Requisito
                        </router-link>
                    </li>
                    <li class="nav-item">
                        <router-link class="nav-link text-active-secondary me-6 " :to="{ name: 'sigap_disciplina_espacos' , params: {  id:model.id  } }"
                            active-class="active">
                            Espaços
                        </router-link>
                    </li>
                    <li class="nav-item" v-if="hasAdmin">
                        <router-link class="nav-link text-active-secondary me-6 " :to="{ name: 'sigap_disciplina_segunda_chamada' , params: {  id:model.id  } }"
                            active-class="active">
                            2ª Chamada
                        </router-link>
                    </li> 
                </ul>
            </div>
        </div>
    </div>
 
    <router-view :key="identificador" :disciplina="model" v-if="model"></router-view>
  
</template>

<script lang="ts">
import CardRh from "@/components/cards/ManzaCard.vue"
import DisciplinaService from "@/service/v1/sigap/DisciplinaService"
import { Options, Vue } from "vue-class-component";
import SiteUtils from '@/assets/ts/aplicacao/site';
import KDataTable from "@/components/datatable/newdatatable.vue"
import Editar from "./_Editar.vue" 
import { PerfilConfig } from "@/core/config/PerfisConfig";
import { namespace } from 'vuex-class';
const authStore = namespace('auth');  


@Options({
    name: "DisciplinaShow",
    components: { CardRh, KDataTable, Editar   },
})
export default class DisciplinaShow extends Vue {

    @authStore.Getter
    public perfis!: any

    @authStore.Getter
    public token!: any

    public service = new DisciplinaService(); 
    public model: any = null;
    public identificador: any = 1;
    public model_update: any = null;
    public processando = false;
    public modal_atualizar = 'modal_visualizar_disciplina_update_showing';
    

    get hasPermissao( ): boolean {
        return SiteUtils.hasPermissao( [ PerfilConfig.Admin ,  PerfilConfig.ChefeSTE ,  PerfilConfig.AuxSTE , PerfilConfig.LeituraDE ] ,  this.perfis); 
    }

    get hasPermissaoEditar( ): boolean {
        return SiteUtils.hasPermissao( [ PerfilConfig.Admin ,  PerfilConfig.ChefeSTE ,  PerfilConfig.AuxSTE ] ,  this.perfis); 
    }

    
    get hasAdmin( ): boolean {
        return SiteUtils.hasPermissao( [ PerfilConfig.Admin  ] ,  this.perfis); 
    }

    created() {
        this.buscaDisciplina();
    }
  

    public buscaDisciplina() {
        this.processando = true;
        this.service.getModel(this.$route.params.id)
            .then(response => {
                this.model = JSON.parse(JSON.stringify(response));
                this.model_update =  this.model;
                this.identificador++;
                this.processando = false;
            })
            .catch(error => {
                this.processando = false;
            });
    }

    public setModelUpdate() {
        this.model_update = null;
        setTimeout(() => {
            this.model_update = this.model;
        }, 10);
    }
 
} 
</script>

<style scoped>
    .btn-sm {
        margin-left: 10px;
    }

    .registro-alteracao {
        text-align: right;
    }

    .start-90 {
        left: 97% !important;
    }

    .col-12 {
        margin-bottom: 40px;
    }

    .btn-flex-full {
        max-width: 100%;
        min-width: 100%;
    }

    .nav-line-tabs .nav-item .nav-link { 
        margin: 0 0.8rem !important;
    }

    
    .card-menu{
        background-color: #304988 !important;
    }

    .nav-line-tabs .nav-item .nav-link.active, .nav-line-tabs .nav-item.show .nav-link, .nav-line-tabs .nav-item .nav-link:hover:not(.disabled) { 
        border-bottom: 3px solid #E3A11E; 
    }


</style>
